// look at SwipeableViews for the swipe event handler
// PredictionList and Notifications has the component (tabs)
// Animation from the Notifications is preferred

import React from 'react'
import classNames from 'classnames'
import './TabbedContent.scss'
import { useState } from 'react'
import { useEffect } from 'react'

const TabbedContent = ({
  className,
  contents,
  defaultIndex = 0,
  header,
  tabListTrailing,
  tabListTrailingClassName,
  tabListWrapperClassName,
  contentWrapperClassName,
  ...props
}) => {
  const [activeIndex, setActiveIndex] = useState(props.activeIndex || defaultIndex)

  let index = defaultIndex

  const handleTabClick = (event, clickedIndex) => {
    const ai = props.activeIndex === undefined ? activeIndex : props.activeIndex

    const { onContentChange } = props

    if (clickedIndex !== ai) {
      setActiveIndex(clickedIndex)
      if (onContentChange) onContentChange(clickedIndex)
    }
  }

  useEffect(() => {
    // Only sync when the parent is actually controlling the active index.
    // Without this guard, an undefined prop would wipe the internal default and
    // leave no tab selected on mount.
    if (props.activeIndex !== undefined) setActiveIndex(props.activeIndex)
  }, [props.activeIndex])

  if (props.activeIndex !== undefined) {
    index = props.activeIndex
  } else {
    index = activeIndex
  }
  const content = contents[index]
  const tabbedLabels = () => {
    return contents.map((item, i) => {
      return (
        <button
          key={i}
          type="button"
          role="tab"
          aria-selected={i === index}
          className={classNames('tab-item', {
            'tab-item--active': i === index,
          })}
          onClick={event => {
            handleTabClick(event, i)
          }}
          data-index={i}>
          <div className="btn-content">
            {typeof item.label === 'function' ? item.label() : item.label}
          </div>
        </button>
      )
    })
  }

  const tabList =
    contents.length > 1 ? (
      <nav
        className={classNames('tabbed-container__tab-list', {
          'tabbed-container__tab-list--with-trailing': tabListTrailing,
        })}>
        {tabListTrailing ? (
          <>
            <div className="relative min-w-0 flex-1">{tabbedLabels()}</div>
            <div
              className={classNames(
                'tabbed-container__tab-list-trailing',
                tabListTrailingClassName || 'shrink-0',
              )}>
              {tabListTrailing}
            </div>
          </>
        ) : (
          tabbedLabels()
        )}
      </nav>
    ) : null

  const contentSection = (
    <section className="tabbed-container__content">
      {header && (
        <header className="container-md-wide">
          <div>{header}</div>
        </header>
      )}
      {content && content.render()}
    </section>
  )

  return (
    <div className={classNames(className, 'tabbed-container')}>
      {tabList &&
        (tabListWrapperClassName ? <div className={tabListWrapperClassName}>{tabList}</div> : tabList)}
      {contentWrapperClassName ? (
        <div className={contentWrapperClassName}>{contentSection}</div>
      ) : (
        contentSection
      )}
    </div>
  )
}

export default TabbedContent
